import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2620346a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header_title price" };
const _hoisted_2 = { class: "header_title amount" };
import { useMessage } from '@/const/messages';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        base: null,
        quote: null,
        reverse: { type: Boolean, default: false },
        showTotal: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { format, ORDERBOOK_FIELDS } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["header", { reverse: _unref(store).state.isSmartPhone && props.reverse }])
            }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(format)(_unref(ORDERBOOK_FIELDS).PRICE)) + " (" + _toDisplayString(props.quote) + ")", 1),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(ORDERBOOK_FIELDS).AMOUNT)) + " (" + _toDisplayString(props.base) + ")", 1),
                _withDirectives(_createElementVNode("div", { class: "header_title total_amount" }, _toDisplayString(_unref(format)(_unref(ORDERBOOK_FIELDS).TOTAL_AMOUNT)) + " (" + _toDisplayString(props.base) + ") ", 513), [
                    [_vShow, props.showTotal]
                ])
            ], 2));
        };
    }
});
